import styled, { css } from 'styled-components/macro';
import { BG_GRADIENT_FROM_WHITE_TO_TRANSPARENT, colorCoreWhite1000 } from '@yme/tokens/colors';
import { elevationBottomLvl3 } from '@yme/tokens/elevations';
import { ADAPTIVE } from '@yme/tokens/screen';
export const OverlapContainerStyled = styled.div `
  position: relative;
  box-sizing: border-box;
  overflow: hidden;

  ${({ hasVerticalWhiteGradient }) => hasVerticalWhiteGradient
    ? css `
          background: ${BG_GRADIENT_FROM_WHITE_TO_TRANSPARENT};
        `
    : css `
          background: ${colorCoreWhite1000};
          box-shadow: ${elevationBottomLvl3};
        `}

  ${ADAPTIVE.minWidth.desktop} {
    margin-left: 48px;
    margin-right: 48px;
    margin-top: -48px;
  }

  ${({ bottomIndent }) => css `
      margin-bottom: ${bottomIndent?.sm};

      ${ADAPTIVE.minWidth.tablet} {
        margin-bottom: ${bottomIndent?.md};
      }

      ${ADAPTIVE.minWidth.desktop} {
        margin-bottom: ${bottomIndent?.lg};
      }
    `}
`;
